export default {
  name: 'project_google_location',
  component_path: 'modules/procedures/blocks/BlockLocationAutocomplete'
}